/*
 * @Author: randy
 * @Date: 2020-08-03 13:21:21
 * @LastEditTime: 2020-10-26 14:32:44
 * @Description: 生成路由
 */

// 根级菜单
let rootRouter = null;

if (process.env.VUE_APP_PROJECT === "student") {
  // 学员端layout
  rootRouter = {
    key: "",
    name: "Index",
    path: "/",
    component: "layout/BasicLayout.vue",
    redirect: "/home",
    title: "首页",
    children: []
  };
} else {
  // 内部layout 超级管理员 科室管理员 基地管理员 授课导师 辅导员
  rootRouter = {
    key: "",
    name: "Index",
    path: "/",
    component: "layout/AdminBasicLayout.vue",
    redirect: "/experts",
    title: "首页",
    children: []
  };
}

/**
 * @Author: randy
 * @description: 动态生成菜单
 * @param {type}
 * @return: {Promise<Router>}
 */
export const generatorDynamicRouter = routes => {
  return new Promise((resolve, reject) => {
    try {
      const menuNav = [];
      const childrenNav = [];
      // 后端数据, 根级树数组, 根级 PID为0
      listToTree(routes, childrenNav, 0);
      rootRouter.children = childrenNav;
      menuNav.push(rootRouter);
      const routers = generator(menuNav);
      resolve(routers);
    } catch (e) {
      reject(e);
    }
  });
};

// name	路由名称, 必须设置,且不能重名	string	-
// path 路由路径 必须唯一
// component 路由对应的组件
// redirect	重定向地址, 访问这个路由时,自定进行重定向	string	-
// meta	路由元信息（路由附带扩展信息）	object	{}
// id 路由自身id
// parentId 路由父节点id
// hidden	控制路由是否显示在 sidebar	boolean	false 如果为true则子节点都不会显示
// hideChildrenInMenu	强制菜单显示为Item而不是SubItem	boolean	false 如果为true则子节点都不会显示

// meta 路由元信息
// title	路由标题, 用于显示面包屑, 页面标题 *推荐设置	string	-
// icon	路由在 menu 上显示的图标	[string,svg]	-
// keepAlive	缓存该路由	boolean	false
// target	菜单链接跳转目标（参考 html a 标记）	string	-
// hiddenHeaderContent	*特殊 隐藏 PageHeader 组件中的页面带的 面包屑和页面标题栏	boolean	false
// permission	与项目提供的权限拦截匹配的权限，如果不匹配，则会被禁止访问该路由页面	array	[]

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    const currentRouter = {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: item.path || `${(parent && parent.path) || ""}/${item.key}`,
      // 路由名称
      name: item.name,
      component: resolve => require([`@/${item.component}`], resolve),
      // meta: 页面标题, 菜单图标, 页面权限
      meta: {
        title: item.title,
        icon: item.icon || undefined,
        target: item.target,
        permission: item.buttonsName,
        // 缓存
        keepAlive: item.keepAlive
      },
      // 是否设置了隐藏菜单
      hidden: !item.menuShow,
      // 菜单显示为item
      hideChildrenInMenu: item.hideChildrenInMenu
    };
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    if (!currentRouter.path.startsWith("http")) {
      currentRouter.path = currentRouter.path.replace("//", "/");
    }
    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect);
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter);
    }
    return currentRouter;
  });
};

/**
 * 数组转树形结构
 * @param list 源数组
 * @param tree 树
 * @param parentId 父ID
 */
const listToTree = (list, tree, parentId) => {
  list.forEach(item => {
    // 判断是否为父级菜单
    if (item.parentId === parentId) {
      const child = {
        ...item,
        key: item.key,
        children: []
      };
      // 迭代 list， 找到当前菜单相符合的所有子菜单
      listToTree(list, child.children, item.id);
      // 删掉不存在 children 值的属性
      if (child.children.length <= 0) {
        delete child.children;
      }
      // 加入到树中
      tree.push(child);
    }
  });
};
